











































































































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import RemoveButton from '@front-app/components/buttons/concrete/XButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import {
	FullUser,
	GroupMember,
	GroupMemberWithEmail,
	UserRole,
} from '@front-app/services/UserApi/UserModel';
import { isActiveMember, isInvitedMember } from '@front-app/modules/groupMember/util/role';
import { isExternalMember } from '@front-app/util/user';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { useGroupMemberName } from '@front-app/hooks/useTranslate';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus, useIsSuccess } from '@front-app/hooks/useAsyncStatus';
import { useGroupMembersStore } from '@front-app/store/singletons/GroupMembers';
import { canInviteMembers, canManageMembers } from '@front-app/util/permission';
import { GroupsStore } from '@front-app/store/singletons/Groups';

export default defineComponent({
	components: {
		UserLink,
		SimpleCard,
		UserAvatar,
		CtaButton,
		LoaderState,
		RemoveButton,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		member: {
			type: Object as PropType<GroupMemberWithEmail | GroupMember>,
			required: true,
		},
		fullUser: {
			type: Object as PropType<FullUser>,
			required: true,
		},
		isColleague: Boolean,
		isRemoving: Boolean,
	},
	setup(props, ctx) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const getUsername = useGroupMemberName(ctx);
		const hasLoadedFullUser = useIsSuccess(computed(() => props.fullUser.status));

		function getNameOrEmail(member: GroupMemberWithEmail | GroupMember) {
			if (isExternalMember(member)) {
				return member.email;
			}
			return getUsername(props.member);
		}

		// Secondary actions
		const { removeMembers } = useGroupMembersStore(computed(() => props.groupId));
		const {
			track: trackRemoveMember,
			isLoading: isRemovingMember,
		} = useAsyncStatus();

		const remove = () => {
			const username = getNameOrEmail(props.member);

			// eslint-disable-next-line no-alert
			const continueWithRemoval = window.confirm(ctx.root.$t('group-member.confirm-remove-from-group', [username]) as unknown as string);

			if (!continueWithRemoval) {
				return;
			}

			if (props.member.groupRole === UserRole.EXTERNAL_INVITEE) {
				trackRemoveMember(removeMembers(props.groupId, [], [props.member.id]));
			} else {
				trackRemoveMember(removeMembers(props.groupId, [props.member.id], []));
			}
			ctx.emit('remove', props.member.id);
		};

		return {
			// Group
			group,
			// Member functions
			hasLoadedFullUser,
			// Secondary actions
			isRemovingMember,
			remove,
			// Permissions
			canManageMembers,
			canInviteMembers,
			// Util
			Size,
			ButtonPalettes,
			UserRole,
			isActiveMember,
			isInvitedMember,
			getUsername,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
		};
	},
});
